import { ChangeDetectorRef, Component, Injector, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { UrlServices } from 'src/app/helper/class/url-services';
import { cloneData } from 'src/app/helper/class/utilityHelper';
import { pageInfo } from 'src/app/helper/interface/menu-interface';
import { ResponseData } from 'src/app/helper/interface/response';
import { AlertService } from 'src/app/helper/service/alert.service';
import { PAYMENT_INFO } from '../helper/helper';
import { PaymentsService } from '../services/payments.service';
import { NavigationService } from 'src/app/core/service/navigation.service';
import { ModalService } from 'src/app/shared/service/modal.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-payments-info',
  templateUrl: './payments-info.component.html',
  styleUrl: './payments-info.component.scss'
})
export class PaymentsInfoComponent implements OnInit {
  urlService: any = UrlServices.PAGE_URL;
  dataLoading: boolean = false;
  disabled_save: boolean = false;
  loading: boolean = false;
  organizationData: any = {};
  paymentId: any;
  pageInfo: pageInfo = { title: 'Payment Details' }
  organizationFormData: any = [...cloneData(PAYMENT_INFO)]
  isModal: boolean = false;
  _bsModalRef: BsModalRef = {} as BsModalRef;
  public onClose: Subject<boolean> = new Subject();
  // list: any;
  // orgid: any
  // loading: boolean = false
  // orgData: any;
  // action: any;
  @Input() id: any;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private paymentApi: PaymentsService,
    private modalservice: ModalService,
    private injector: Injector,
  ) { }

  ngOnInit(): void {
    this.paymentId = this.activatedRoute.snapshot.queryParams['id'] || '';
    if (this.paymentId) {
      this.getData();
    }

  }

  setInput(data: any) {
    this.paymentId = data
    this._bsModalRef = this.injector.get<BsModalRef>(BsModalRef);
    this.isModal = true
    if (this.paymentId) {
      this.getData();
    }
  }

  getData() {
    if (this.paymentId && this.paymentId.id) {
      this.dataLoading = true;
      const api = this.paymentApi.paymentGetById(this.paymentId.id);
      api.then((res: ResponseData) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          const result = res.result;
          const d: any = [];
          this.organizationData = result;
        }
      }).catch((err: any) => { this.alertService.showToast(err ? err : 'Unable to complete the process', 'error'); console.log(err) }).finally(() => this.dataLoading = false)
    }
  }


  close() {
    if (this.isModal) {
      this._bsModalRef.hide()
    } else {
      this.router.navigate([UrlServices.PAGE_URL.PAYMENTS.LIST.URL])
    }
  }
}